import React from 'react';
import { useTranslation } from 'react-i18next';
import { PRICE_UNITS } from '../../../utils/constants';

interface PriceInputProps {
  unitPrice: string;
  priceUnit: string;
  purchasePrice: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  errors: {
    unit_price?: string;
    purchase_price?: string;
  };
  disabled?: boolean;
}

export const PriceInput: React.FC<PriceInputProps> = ({
  unitPrice,
  priceUnit,
  purchasePrice,
  onChange,
  errors,
  disabled = false
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label htmlFor="unit_price" className="block text-sm font-medium text-gray-700">
          {t('sales.unitPrice')} *
        </label>
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-2">
            <input
              type="number"
              id="unit_price"
              name="unit_price"
              value={unitPrice}
              onChange={onChange}
              disabled={disabled}
              min="0"
              step="0.01"
              className="w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
              placeholder={t('common.price')}
            />
          </div>
          <select
            id="price_unit"
            name="price_unit"
            value={priceUnit}
            onChange={onChange}
            disabled={disabled}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
          >
            {PRICE_UNITS.map(({ value, label }) => (
              <option key={value} value={value}>{t(label)}</option>
            ))}
          </select>
        </div>
        {errors.unit_price && (
          <p className="mt-1 text-sm text-red-600">{errors.unit_price}</p>
        )}
      </div>

      <div className="space-y-2">
        <label htmlFor="purchase_price" className="block text-sm font-medium text-gray-700">
          {t('sales.purchasePrice')}
        </label>
        <input
          type="number"
          id="purchase_price"
          name="purchase_price"
          value={purchasePrice}
          onChange={onChange}
          disabled={disabled}
          min="0"
          step="0.01"
          className="w-full rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500 sm:text-sm"
          placeholder={t('sales.purchasePrice')}
        />
        {errors.purchase_price && (
          <p className="mt-1 text-sm text-red-600">{errors.purchase_price}</p>
        )}
      </div>
    </div>
  );
};